import { z } from 'zod';
import { Icon } from '#common/components/Icon';

export const linkTypes = [ 'xing', 'linked-in', 'instagram', 'tiktok', 'facebook', 'homepage', 'other' ] as const;

export const linkTypeSchema = z.enum(linkTypes);
export type LinkType = z.infer<typeof linkTypeSchema>;

export function mapLinkTypeToIconName(linkType: LinkType) {
    switch (linkType) {
        case 'xing':
            return 'fa6-brands--xing';
        case 'linked-in':
            return 'fa6-brands--linkedin-in';
        case 'instagram':
            return 'fa6-brands--instagram';
        case 'tiktok':
            return 'fa6-brands--tiktok';
        case 'facebook':
            return 'fa6-brands--facebook-f';
        case 'homepage':
            return 'heroicons--globe-alt';
        case 'other':
            return 'fa6-solid--link';
        default:
            throw new Error(`Unknown link type: ${linkType}`);
    }
}

export function LinkTypeIcon({ type, className }: { type: LinkType; className?: string }) {
    return <Icon icon={mapLinkTypeToIconName(type)} className={className} />;
}
